:host {
    display: block;
}
atlantis-pagination::part(pagination) {
    border-radius: 5px;
}